module.exports = __webpack_public_path__ + "static/features-workers-main-73ed66d0e335bb1fd21f84649ada9003.png";